export default __webpack_public_path__ + "static/media/DHL-ALEMANIA-PACKET.8637aad3.svg";